import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api';

interface Overview {
  accounts: { id: number; wx_account_id: number; appid: string | null; display_name: string | null }[];
  stats: { users: number; subscribed: number; notifications: number; notifications_today: number; keywords: number };
}

export default function DashboardPage() {
  const { data, isLoading, error } = useQuery<Overview>({
    queryKey: ['dashboard-overview'],
    queryFn: () => api.get<Overview>('/api/dashboard/overview'),
  });

  if (isLoading) return <div className="text-slate-500">加载中...</div>;
  if (error) return <div className="rounded bg-red-50 px-3 py-2 text-sm text-red-700">{(error as Error).message}</div>;

  const stats = data?.stats ?? { users: 0, subscribed: 0, notifications: 0, notifications_today: 0, keywords: 0 };
  const items = [
    { label: '粉丝总数', value: stats.users },
    { label: '已订阅', value: stats.subscribed },
    { label: '通知总数', value: stats.notifications },
    { label: '今日通知', value: stats.notifications_today },
    { label: '关键词总数', value: stats.keywords },
  ];

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-semibold text-slate-800">概览</h2>
        <p className="mt-1 text-sm text-slate-500">汇总当前租户名下所有公众号的关键指标。</p>
      </div>
      <div className="grid grid-cols-2 gap-4 md:grid-cols-5">
        {items.map((it) => (
          <div key={it.label} className="card">
            <div className="text-xs text-slate-500">{it.label}</div>
            <div className="mt-1 text-2xl font-semibold text-slate-800">{it.value}</div>
          </div>
        ))}
      </div>
      <div className="card">
        <h3 className="text-sm font-medium text-slate-700">公众号</h3>
        <ul className="mt-3 divide-y divide-slate-100">
          {(data?.accounts ?? []).map((a) => (
            <li key={a.id} className="flex items-center justify-between py-2 text-sm">
              <span className="text-slate-700">{a.display_name || a.appid || `#${a.wx_account_id}`}</span>
              <span className="text-slate-400">ID {a.wx_account_id}</span>
            </li>
          ))}
          {(data?.accounts ?? []).length === 0 && (
            <li className="py-2 text-sm text-slate-500">尚未绑定任何公众号，请联系超管在「公众号」页面绑定。</li>
          )}
        </ul>
      </div>
    </div>
  );
}
